import { NavLink } from 'react-router-dom';

const Header = ({isFullSidebar}) => {
    return(
        <div className="sidenav-header">
            <i 
                className="fas fa-times p-3 cursor-pointer text-dark opacity-5 position-absolute end-0 top-0 d-none d-xl-none" 
                aria-hidden="true" 
                id="iconSidenav"
            />
            <NavLink className={`navbar-brand ps-4 pe-4 py-${isFullSidebar ? '4' : '3'} m-0`} to="/home">
                <img 
                    src={`/assets/img/${isFullSidebar ? 'instafix-logo-long.png' : 'Instafix-fav.png'}`}
                    width="200"
                    height="25"
                    className="navbar-brand-img" 
                    alt="main_logo"
                />
                {!isFullSidebar && <span className="ms-1 text-sm text-success mt-1" style={{fontWeight: "bold"}}>{process.env.REACT_APP_SYSTEM_NAME}</span>}
            </NavLink>
        </div>
    );
}

export default Header;